module.exports = __webpack_public_path__ + "img/f-instagram.42bc2575.svg";